namespace RedBullMOBILE360.PushNotifications {
    export interface PushNotificationsRow {
        Id?: number;
        NotificationDate?: string;
        Sender?: string;
        Status?: number;
        ExcelFileName?: string;
        IsExcelUploaded?: number;
    }

    export namespace PushNotificationsRow {
        export const idProperty = 'Id';
        export const nameProperty = 'Sender';
        export const localTextPrefix = 'PushNotifications.PushNotifications';
        export const deletePermission = 'PushNotifications';
        export const insertPermission = 'PushNotifications';
        export const readPermission = 'PushNotifications';
        export const updatePermission = 'PushNotifications';

        export declare const enum Fields {
            Id = "Id",
            NotificationDate = "NotificationDate",
            Sender = "Sender",
            Status = "Status",
            ExcelFileName = "ExcelFileName",
            IsExcelUploaded = "IsExcelUploaded"
        }
    }
}
